import React, { useContext, useState } from "react";
import { TableTitle } from "../../Material/single/MaterialList/Styled";
import { StyledTableCell } from "../../../shared/components/CustomTable/Styled";
import { ItemList as ProductExportList, ItemListItem as ProductExportListItem, ItemListItemQuantity as ProductExportListItemQuantity } from "../../../shared/styled/ListItemStyles";
import { IconButton, ListItem, ListItemText, TableRow } from "@mui/material";
import { generateDocument, generateDocumentBlob } from "../../../utils/exportUtils";
import Template from "../../../templates/PMS - Phiếu xuất kho thành phẩm.docx";
import { buildDocxData } from "../../../utils/docxBuilder";
import { productExportHistoryDownloadDescriptor } from "../../../utils/docxMappings";
import ListView from "../../../shared/components/ListView";
import { ProductsExportFilterType } from "../../../configs/filterTypes";
import { ProductsExportSortTypes } from "../../../configs/sortTypes";
import { ProductExport } from "../../../data/entities";
import dayjs from "dayjs";
import { formatToCustomDateString } from "../../../utils/dateUtils";
import { DEFAULT_DATE_FORMAT } from "../../../configs/dateConfig";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DocxPreviewModal from "../../../shared/components/DocxPreviewModal";
import DownloadIcon from "@mui/icons-material/Download";
import { StyledButton } from "../../../shared/styled/TitleBar";
import ProductHistoryDeepLinkPreview from "../ProductHistoryDeepLinkPreview";
const ProductExportImportHistoryTableColumns = [
    {
        text: 'Mã phiếu',
        icon: <></>
    },
    {
        text: 'Kho',
        icon: <></>
    },
    {
        text: 'Khách hàng',
        icon: <></>
    },
    {
        text: 'Người nhận',
        icon: <></>
    },
    {
        text: 'Địa chỉ',
        icon: <></>
    },
    {
        text: 'Phương thức xuất',
        icon: <></>
    },
    {
        text: 'Ghi chú',
        icon: <></>
    },
    {
        text: 'Sản phẩm xuất',
        icon: <></>
    },
    {
        text: 'Ngày tạo',
        icon: <></>
    },
    {
        text: 'Ngày xuất kho',
        icon: <></>
    },

    {
        text: 'Xem trước',
        icon: <></>
    },
];


interface ProductExportImportHistoryRowProps {
    item: ProductExport;
    extraRowProps: any;
}

const ProductExportImportHistoryRow = ({ item, extraRowProps }: ProductExportImportHistoryRowProps) => {
    const {
        user: {role}
    } = useContext(AuthenticationContext);
    //const itemDate = new Date(item.created_at);
    const itemExportDate = dayjs(item.export_date).utc();
    // Format the XK ID
    const itemExportDateString = formatToCustomDateString(item.export_date, DEFAULT_DATE_FORMAT);

    const exportData = buildDocxData(item, productExportHistoryDownloadDescriptor);

    const onClickDownload = () => {
        generateDocument(exportData, Template, `phieu_xuat_kho_${item.storage}_${itemExportDateString}`);
    }

    const [previewBlob, setPreviewBlob] = useState<Blob | null>(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const onClickPreview = () => {
        generateDocumentBlob(exportData, Template).then((blob) => {
            console.debug("Generated DOCX blob for preview", { size: blob.size, type: blob.type });
            setPreviewBlob(blob);
            setIsPreviewOpen(true);
        });
    }


    return (
        <>
            <TableRow>
            <StyledTableCell>{item.export_code}</StyledTableCell>
            {(![ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role)) && (
                <StyledTableCell style={{ whiteSpace: 'nowrap', wordBreak: 'keep-all' }}>{item.storage}</StyledTableCell>
            )}
            <StyledTableCell>{item.customer}</StyledTableCell>
            <StyledTableCell>{item.receiver_name}</StyledTableCell>
            <StyledTableCell>{item.address}</StyledTableCell>
            <StyledTableCell>{item.reason}</StyledTableCell>
            <StyledTableCell>{item.note}</StyledTableCell>
            <StyledTableCell>
                <ProductExportList>
                    {item.products.map((product, index) => (
                        <ListItem 
                            key={product.product.id || index}
                            dense
                            disableGutters
                            style={{ padding: '2px 0' }}
                        >
                            <ListItemText
                                primary={
                                    <ProductExportListItem>        
                                        <span>{product.product.name}</span>
                                        <ProductExportListItemQuantity>
                                            x{product.quantity}
                                        </ProductExportListItemQuantity>
                                    </ProductExportListItem>
                                }
                            />
                        </ListItem>
                    ))}
                </ProductExportList>
            </StyledTableCell>
            <StyledTableCell>{formatToCustomDateString(item.created_at, DEFAULT_DATE_FORMAT)}</StyledTableCell>
            <StyledTableCell>{itemExportDateString}</StyledTableCell>
            <StyledTableCell>
                <IconButton onClick={onClickPreview} title="Xem trước phiếu">
                    <VisibilityIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
        
        <DocxPreviewModal
            open={isPreviewOpen}
            onClose={() => setIsPreviewOpen(false)}
            blob={previewBlob}
            title="Xem trước phiếu xuất kho thành phẩm"
            debug={false}
            actions={
                <StyledButton
                    variant="outlined"
                    onClick={onClickDownload}
                >
                    <DownloadIcon style={{ marginRight: '8px' }} />
                    Tải phiếu
                </StyledButton>
            }
        />
        </>
    );
};

const ProductExportImportHistory = () => {
    const {
        user: {role}
    } = useContext(AuthenticationContext);

    const getExportColumns = () => {
        const getColumns = ProductExportImportHistoryTableColumns;
        if ([ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role)) {
            return getColumns.filter(({ text }) => text !== 'Kho');
        }
        return getColumns;
    }


    return (
        <>
            <ListView
                url="/products/export/"
                filterTypes={ProductsExportFilterType}
                sortTypes={ProductsExportSortTypes}
                rowElement={ProductExportImportHistoryRow}
                tableColumns={getExportColumns()}
                textString={"Tìm kiếm theo tên khách hàng, mã phiếu xuất kho"}
            />
            <ProductHistoryDeepLinkPreview kind="export" />
        </>
    );
};

export default ProductExportImportHistory; 
